/*
 * NEGOTIA Business Gear Utility Engine - core (uge-core.js)
 * Rules mirror operations/utility-engine-rules.md exactly. Do not change a rule here without a new rule version.
 * Archetypes: Matcher (laptop fit), Converter (inch <-> cm).
 */
(function () {
  'use strict';

  var UGE = window.UGE || {};

  /* ---------- RULE: FIT-LAPTOP v1 ---------- */
  UGE.FIT_LAPTOP_VERSION = 'FIT-LAPTOP v1';
  UGE.CLASS_ORDER = { excellent: 0, fits: 1, snug: 2, not_recommended: 3, no_fit: 4, unknown: 5 };

  // d: {w, d, t, k (size_class), c (confidence)}; p: {l, s, dp, m (max_in), b (basis)}
  UGE.fitLaptop = function (d, p) {
    if (!d || !p || !(d.w > 0) || !(d.d > 0) || !(d.t > 0) || !(p.l > 0) || (d.c || 0) < 0.8) return 'unknown';
    var L = Math.max(d.w, d.d), S = Math.min(d.w, d.d);
    var cl = p.l - L, cs = p.s - S, ct = p.dp - d.t;
    if (cl < 0 || cs < 0 || ct < 0) return 'no_fit';
    if (d.k > p.m + 0.05) return 'not_recommended';
    var m = Math.min(cl, cs);
    if (m < 10) return 'snug';
    if (p.b === 'measured' && m <= 25) return 'excellent';
    return 'fits';
  };

  UGE.clearance = function (d, p) {
    return { long: Math.round(p.l - Math.max(d.w, d.d)), short: Math.round(p.s - Math.min(d.w, d.d)), depth: Math.round(p.dp - d.t) };
  };

  /* ---------- CONVERTER: inch <-> cm (exact) ---------- */
  UGE.INCH_MM = 25.4;
  UGE.inchToCm = function (inch) { return Math.round(inch * 2.54 * 10) / 10; };
  UGE.cmToInch = function (cm) { return Math.round((cm / 2.54) * 10) / 10; };

  /* ---------- Events ---------- */
  UGE.track = function (name, params) {
    try {
      params = params || {};
      params.locale = document.documentElement.lang || '';
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params));
    } catch (e) {}
  };

  function norm(s) { return (s || '').toLowerCase().replace(/[^a-z0-9.]+/g, ' ').trim(); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(n) { return (Math.round(n * 10) / 10).toLocaleString(document.documentElement.lang || 'en'); }

  /* ---------- MATCHER UI: laptop fit checker ---------- */
  function initFit(root) {
    var dataEl = root.querySelector('script[data-uge-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var L = data.labels;
    var devices = data.devices.filter(function (d) { return d.cat === 'laptop'; });
    devices.sort(function (a, b) { return a.pop - b.pop; });
    var input = root.querySelector('[data-uge-search]');
    var list = root.querySelector('[data-uge-suggest]');
    var out = root.querySelector('[data-uge-result]');
    var tool = root.getAttribute('data-uge-tool') || 'laptop-fit-checker';
    var lastQuery = '';

    UGE.track('uge_tool_view', { tool: tool, rule_version: UGE.FIT_LAPTOP_VERSION });

    function score(d, q) {
      var hay = norm(d.name + ' ' + d.brand + ' ' + d.family + ' ' + (d.aliases || []).join(' ') + ' ' + (d.gens || []).join(' '));
      var parts = q.split(' ').filter(Boolean), s = 0;
      for (var i = 0; i < parts.length; i++) { if (hay.indexOf(parts[i]) === -1) return -1; s += 1; }
      return s * 100 - d.pop;
    }

    function suggest(q) {
      q = norm(q);
      if (!q) { list.hidden = true; list.innerHTML = ''; return; }
      var hits = devices.map(function (d) { return [score(d, q), d]; }).filter(function (x) { return x[0] >= 0; })
        .sort(function (a, b) { return b[0] - a[0]; }).slice(0, 8);
      if (!hits.length) {
        list.innerHTML = '<li class="uge-suggest__empty">' + esc(L.no_device) + '</li>';
        list.hidden = false;
        if (q.length > 3 && q !== lastQuery) { lastQuery = q; UGE.track('uge_no_result', { tool: tool, term: q }); }
        return;
      }
      list.innerHTML = hits.map(function (x) { return '<li><button type="button" data-h="' + esc(x[1].h) + '">' + esc(x[1].name) + '</button></li>'; }).join('');
      list.hidden = false;
    }

    function render(d) {
      list.hidden = true;
      input.value = d.name;
      UGE.track('uge_query', { tool: tool, term: d.h, rule_version: UGE.FIT_LAPTOP_VERSION });
      var seen = {}, rows = [];
      data.products.forEach(function (p) {
        if (seen[p.title]) return;
        var c = UGE.fitLaptop(d, p);
        rows.push({ p: p, c: c, cl: UGE.clearance(d, p) });
        seen[p.title] = true;
      });
      rows.sort(function (a, b) { return (UGE.CLASS_ORDER[a.c] - UGE.CLASS_ORDER[b.c]) || (a.p.price - b.p.price); });
      var good = rows.filter(function (r) { return r.c === 'fits' || r.c === 'snug' || r.c === 'excellent'; });
      var rest = rows.filter(function (r) { return !(r.c === 'fits' || r.c === 'snug' || r.c === 'excellent'); });
      UGE.track('uge_result', { tool: tool, device: d.h, matches: good.length, rule_version: UGE.FIT_LAPTOP_VERSION });

      var html = '<p class="uge-answer">' + esc(L.answer.replace('{device}', d.name).replace('{w}', fmt(d.w)).replace('{d}', fmt(d.d)).replace('{t}', fmt(d.t)).replace('{n}', good.length)) + '</p>';
      html += '<div class="uge-cards">' + good.map(card).join('') + '</div>';
      if (rest.length) {
        html += '<details class="uge-rest"><summary>' + esc(L.not_suitable) + ' (' + rest.length + ')</summary><ul>' +
          rest.map(function (r) { return '<li><a href="' + esc(r.p.url) + '">' + esc(r.p.title) + '</a>: ' + esc(L['c_' + r.c]) + '</li>'; }).join('') + '</ul></details>';
      }
      if (d.url) html += '<p class="uge-more"><a href="' + esc(d.url) + '">' + esc(L.device_page.replace('{device}', d.name)) + '</a></p>';
      out.innerHTML = html;
      out.hidden = false;
    }

    function card(r) {
      var p = r.p;
      return '<a class="uge-card" href="' + esc(p.url) + '" data-uge-product="' + esc(p.handle) + '">' +
        (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400">' : '') +
        '<span class="uge-badge uge-badge--' + r.c + '">' + esc(L['c_' + r.c]) + '</span>' +
        '<span class="uge-card__title">' + esc(p.title) + '</span>' +
        '<span class="uge-card__meta">' + esc(L.clearance.replace('{mm}', Math.min(r.cl.long, r.cl.short))) + '</span>' +
        '<span class="uge-card__price">' + esc(p.price_f) + (p.avail ? '' : ' · ' + esc(L.sold_out)) + '</span></a>';
    }

    input.addEventListener('input', function () { suggest(input.value); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { var b = list.querySelector('button'); if (b) { e.preventDefault(); b.click(); } }
    });
    list.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-h]'); if (!b) return;
      var d = devices.filter(function (x) { return x.h === b.getAttribute('data-h'); })[0];
      if (d) render(d);
    });
    out.addEventListener('click', function (e) {
      var a = e.target.closest('[data-uge-product]');
      if (a) UGE.track('uge_product_click', { tool: tool, product: a.getAttribute('data-uge-product'), rule_version: UGE.FIT_LAPTOP_VERSION });
    });
    root.querySelectorAll('[data-uge-quick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = devices.filter(function (x) { return x.h === b.getAttribute('data-uge-quick'); })[0];
        if (d) render(d);
      });
    });
    var pre = root.getAttribute('data-uge-preselect');
    if (pre) { var d0 = devices.filter(function (x) { return x.h === pre; })[0]; if (d0) render(d0); }
  }

  /* ---------- CONVERTER UI: inch <-> cm ---------- */
  function initConvert(root) {
    var dataEl = root.querySelector('script[data-uge-data]');
    var data = dataEl ? JSON.parse(dataEl.textContent) : { labels: {}, ranges: [] };
    var L = data.labels;
    var inch = root.querySelector('[data-uge-inch]');
    var cm = root.querySelector('[data-uge-cm]');
    var out = root.querySelector('[data-uge-convert-result]');
    var tool = 'laptop-inch-cm';
    UGE.track('uge_tool_view', { tool: tool, rule_version: 'CONVERT-INCH v1' });

    function rangeFor(i) {
      var best = null;
      (data.ranges || []).forEach(function (r) { if (best === null || Math.abs(r.k - i) < Math.abs(best.k - i)) best = r; });
      return best && Math.abs(best.k - i) <= 0.8 ? best : null;
    }
    function show(i) {
      if (!(i > 0)) { out.hidden = true; return; }
      var c = UGE.inchToCm(i);
      var html = '<p class="uge-answer">' + esc(L.answer.replace('{in}', fmt(i)).replace('{cm}', fmt(c))) + '</p>';
      var r = rangeFor(i);
      if (r) html += '<p>' + esc(L.body.replace('{in}', fmt(r.k)).replace('{wmin}', fmt(r.wmin / 10)).replace('{wmax}', fmt(r.wmax / 10)).replace('{dmin}', fmt(r.dmin / 10)).replace('{dmax}', fmt(r.dmax / 10)).replace('{n}', r.n)) + '</p>';
      if (L.cta_url) html += '<p class="uge-more"><a href="' + esc(L.cta_url) + '">' + esc(L.cta) + '</a></p>';
      out.innerHTML = html; out.hidden = false;
    }
    var t;
    inch.addEventListener('input', function () {
      var i = parseFloat(inch.value.replace(',', '.'));
      cm.value = i > 0 ? String(UGE.inchToCm(i)) : '';
      show(i);
      clearTimeout(t); t = setTimeout(function () { if (i > 0) UGE.track('uge_query', { tool: tool, term: String(i) + 'in' }); }, 800);
    });
    cm.addEventListener('input', function () {
      var c = parseFloat(cm.value.replace(',', '.'));
      var i = c > 0 ? UGE.cmToInch(c) : 0;
      inch.value = i > 0 ? String(i) : '';
      show(i);
      clearTimeout(t); t = setTimeout(function () { if (c > 0) UGE.track('uge_query', { tool: tool, term: String(c) + 'cm' }); }, 800);
    });
    root.querySelectorAll('[data-uge-size]').forEach(function (b) {
      b.addEventListener('click', function () { inch.value = b.getAttribute('data-uge-size'); inch.dispatchEvent(new Event('input')); });
    });
  }

  UGE.init = function () {
    document.querySelectorAll('[data-uge-fit]:not([data-uge-ready])').forEach(function (el) { el.setAttribute('data-uge-ready', ''); initFit(el); });
    document.querySelectorAll('[data-uge-convert]:not([data-uge-ready])').forEach(function (el) { el.setAttribute('data-uge-ready', ''); initConvert(el); });
  };

  window.UGE = UGE;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', UGE.init); else UGE.init();
  document.addEventListener('shopify:section:load', UGE.init);
})();
